import { useEffect, useState } from 'react'

import type { AgoraRTCClientWrapper } from '@core/agoraRTC/libs/AgoraRTCClientWrapper'

/**
 * Hook that listen to the client role change and update the state.
 * @returns The client role.
 */
export function useClientRole(agoraClient: AgoraRTCClientWrapper | undefined) {
  const [clientRole, setClientRole] = useState(
    agoraClient?.clientRole ?? 'audience',
  )

  useEffect(() => {
    return agoraClient?.onClientRoleChange((role) => {
      setClientRole(role)
    })
  }, [agoraClient])

  return clientRole
}
